import { render, staticRenderFns } from "./ConveyorConfig.vue?vue&type=template&id=11fae85a"
import script from "./ConveyorConfig.vue?vue&type=script&lang=js"
export * from "./ConveyorConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports